import InsertChartOutlinedRoundedIcon from '@mui/icons-material/InsertChartOutlinedRounded';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import LiveHelpOutlinedIcon from '@mui/icons-material/LiveHelpOutlined';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';

export const SidebarData = [
    {
        title: 'dashboard',
        path: '/Dashboard',
        icon: <InsertChartOutlinedRoundedIcon />,
        cName: 'nav-text',
        acesso: '',
    },
    {
        title: 'Leads',
        path: '/Leads',
        icon: <GroupsOutlinedIcon />,
        cName: 'nav-text',
        acesso: '',
    },
    {
        title: 'Contas',
        path: '/Prospects',
        icon: <PeopleAltOutlinedIcon />,
        cName: 'nav-text',
        acesso: 'GESBPP',
    },

    {
        title: 'agendamentos',
        path: '/Agendamentos',
        icon: <CalendarTodayOutlinedIcon />,
        cName: 'nav-text',
        acesso: 'GESBAP',
    },
    {
        title: 'catalogo',
        path: '/Catalogo',
        icon: <AutoStoriesOutlinedIcon />,
        cName: 'nav-text',
        acesso: '',
    },
    {
        title: 'carrinho',
        path: '/Carrinho',
        icon: <ShoppingCartOutlinedIcon />,
        cName: 'nav-text',
        acesso: 'GESOPP',
    },
    {
        title: 'negocios',
        path: '/NegociosEtapas',
        icon: <HandshakeOutlinedIcon />,
        cName: 'nav-text',
        acesso: 'GESOPP',
    },
    {
        title: 'propostas',
        path: '/Propostas',
        icon: <PostAddOutlinedIcon />,
        cName: 'nav-text',
        acesso: 'GESSQH',
    },

    {
        title: 'despesas',
        path: '/Despesas',
        icon: <MonetizationOnOutlinedIcon />,
        cName: 'nav-text',
        acesso: 'GESYDESPESA',
    },
    {
        title: 'questionarios',
        path: '/Questionarios',
        icon: <LiveHelpOutlinedIcon />,
        cName: 'nav-text',
        acesso: 'GESYDESPESA',
    },
    {
        title: 'relatorios',
        path: '/Relatorios',
        icon: <QueryStatsRoundedIcon />,
        cName: 'nav-text',
        acesso: 'GESYDESPESA',
    },
];
